import React from 'react'
import FormModal from '../../components/form/FormModal'

function Login() {
  return (
    <FormModal isLogin />
  )
}

export default Login